import { render, staticRenderFns } from "./PartCategoryForm.vue?vue&type=template&id=5d19aa5d"
import script from "./PartCategoryForm.vue?vue&type=script&lang=ts"
export * from "./PartCategoryForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports